import { LuActivity, LuBone, LuDroplets, LuHeartPulse } from 'react-icons/lu'

export const areas = [
  { title: 'Diabetes support', icon: LuDroplets },
  { title: 'High blood pressure support', icon: LuHeartPulse },
  { title: 'Arthritis and joint wellbeing', icon: LuBone },
  { title: 'Sickle cell wellbeing support', icon: LuActivity },
]
